// src/routes.js
import React, { lazy } from "react";
import {
  ChangePassword,
  ApplicationLogin,
  MultiApplicationPage,
  AwardsPage,
} from "./components";
import SelectionCommitteeTab from "./components/admin/selCom/SelectionCommitteeTab";
import Stats from "./components/admin/Stats";

const AdminDashboard = lazy(() => import("./components/admin/AdminDashboard"));
const AdminImpersonationPage = lazy(() =>
  import("./components/admin/students/AdminImpersonationPage")
);

export const routes = [
  {
    path: "/login",
    element: <ApplicationLogin />,
  },
  {
    path: "/awards-page",
    element: <AwardsPage />,
  },
];

export const protectedRoutes = [
  { path: "/admin", element: <AdminDashboard /> },
  { path: "/selcom", element: <SelectionCommitteeTab /> },
  { path: "/stats", element: <Stats /> },
  { path: "/", element: <MultiApplicationPage /> },
  { path: "/change-password", element: <ChangePassword /> },
  {
    path: "/admin/application-view/:studentId",
    element: <AdminImpersonationPage />,
  },
];
